/* @flow strict */

import './styles.scss';

const CssPinner = (el: string, status: boolean): any => {
  if (!el) {
    console.warn('Elemnet which should show preload spinner is required');
    return false;
  }
  if (status) {
    el.classList.add('csspinner');
  } else {
    el.classList.remove('csspinner');
  }
};

export default CssPinner;
